/* Shared headliner lightbox behaviour. Markup: snippets/ua-headliner-lightbox.liquid.
   Loaded (deferred) once per page by the sections that render the snippet. */
(function () {
  if (window.__uaHeadlinerLightbox) return;
  window.__uaHeadlinerLightbox = true;

  var current = null; // the open lightbox, if any

  function state(lb) {
    if (lb.__uaHl) return lb.__uaHl;
    var swiperEl = lb.querySelector('.ua-hl-lightbox__swiper');
    var slides = swiperEl.querySelectorAll('.swiper-wrapper > .swiper-slide');
    var s = {
      el: lb,
      swiperEl: swiperEl,
      slides: slides,
      total: slides.length,
      captions: Array.prototype.map.call(slides, function (sl) { return sl.getAttribute('data-caption') || ''; }),
      counter: lb.querySelector('.ua-hl-lightbox__counter'),
      caption: lb.querySelector('.ua-hl-lightbox__caption'),
      closeBtn: lb.querySelector('.ua-hl-lightbox__close'),
      swiper: null,
      lastFocus: null
    };
    lb.__uaHl = s;
    return s;
  }

  // Slides carry data-hl-src instead of src, so opening the gallery downloads the photo on screen and the
  // one either side (wrapping, since the arrows rewind), not all of them (Nov 2 2026, Supabase bandwidth).
  function loadNear(s, index) {
    [index - 1, index, index + 1].forEach(function (i) {
      var im = s.slides[(i + s.total) % s.total].querySelector('img[data-hl-src]');
      if (!im) return;
      im.src = im.getAttribute('data-hl-src');
      im.removeAttribute('data-hl-src');
    });
  }

  function render(s, index) {
    loadNear(s, index);
    s.counter.textContent = s.total > 1 ? (index + 1) + ' / ' + s.total : '';
    s.caption.textContent = s.captions[index] || '';
  }

  function ensureSwiper(s, startIndex) {
    if (s.swiper) {
      s.swiper.update();
      s.swiper.slideTo(startIndex, 0, false);
      render(s, s.swiper.activeIndex);
      return;
    }
    if (typeof Swiper === 'undefined') {
      // Swiper is deferred in theme.liquid and present by the time a tap can
      // happen; this guard just keeps the image visible if it ever is not.
      Array.prototype.forEach.call(s.slides, function (sl, i) { sl.style.display = i === startIndex ? '' : 'none'; });
      render(s, startIndex);
      return;
    }
    // rewind (not loop) keeps slideTo deterministic when the lightbox is
    // reopened on a different tile; arrows and keys still wrap last -> first.
    s.swiper = new Swiper(s.swiperEl, {
      initialSlide: startIndex,
      rewind: s.total > 1,
      watchOverflow: true,
      grabCursor: true,
      navigation: {
        nextEl: s.swiperEl.querySelector('.swiper-button-next'),
        prevEl: s.swiperEl.querySelector('.swiper-button-prev')
      },
      zoom: { maxRatio: 3 },
      on: {
        init: function (sw) { render(s, sw.activeIndex); },
        slideChange: function (sw) { render(s, sw.activeIndex); }
      }
    });
  }

  /* Swipe down to dismiss.
     Phones expect a downward flick to close a fullscreen image, and until the
     close button was fixed this gallery had no exit at all on iOS. Bound once
     per lightbox, on the root, so it survives reopening.

     The gesture has to share the screen with Swiper's horizontal drag and with
     pinch zoom, so it only claims a touch that is clearly vertical and
     downward, and it stands down entirely while an image is zoomed in. */
  var DISMISS_PX = 110;   // far enough that a hesitant drag springs back
  var FLICK_MS = 300;     // a quick flick closes without travelling as far

  function bindDismiss(s) {
    if (s.dismissBound) return;
    s.dismissBound = true;

    var content = s.el.querySelector('.ua-hl-lightbox__content');
    var backdrop = s.el.querySelector('.ua-hl-lightbox__backdrop');
    if (!content) return;

    var startX = 0, startY = 0, dy = 0, startedAt = 0;
    var dragging = false, decided = false;

    function clear() {
      s.el.classList.remove('is-dragging');
      content.style.transform = '';
      if (backdrop) backdrop.style.opacity = '';
    }
    s.clearDrag = clear;

    s.el.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      // Leave a zoomed image alone: panning it is not a dismiss.
      if (s.swiper && s.swiper.zoom && s.swiper.zoom.scale > 1) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      startedAt = Date.now();
      dy = 0;
      dragging = false;
      decided = false;
    }, { passive: true });

    s.el.addEventListener('touchmove', function (e) {
      if (e.touches.length !== 1 || (decided && !dragging)) return;
      var x = e.touches[0].clientX - startX;
      var y = e.touches[0].clientY - startY;

      if (!decided) {
        if (Math.abs(x) < 8 && Math.abs(y) < 8) return; // still a tap
        decided = true;
        // Downward, and meaningfully more vertical than horizontal, so a
        // slightly sloppy sideways slide still changes headliner.
        dragging = y > 0 && y > Math.abs(x) * 1.2;
        if (!dragging) return;
        s.el.classList.add('is-dragging');
        if (s.swiper) s.swiper.allowTouchMove = false;
      }

      dy = Math.max(0, y);
      content.style.transform = 'translateY(' + dy + 'px)';
      // Fade the frosted backdrop out as it goes, so the page behind reappears
      // and the gesture reads as "putting it back".
      if (backdrop) backdrop.style.opacity = String(Math.max(0, 1 - dy / 420));
    }, { passive: true });

    function end() {
      if (s.swiper) s.swiper.allowTouchMove = true;
      if (!dragging) return;
      dragging = false;
      var flicked = Date.now() - startedAt < FLICK_MS && dy > 40;
      if (dy > DISMISS_PX || flicked) {
        clear();
        close();
      } else {
        s.el.classList.remove('is-dragging'); // let CSS spring it back
        content.style.transform = '';
        if (backdrop) backdrop.style.opacity = '';
      }
    }
    s.el.addEventListener('touchend', end);
    s.el.addEventListener('touchcancel', end);
  }

  function onKeydown(e) {
    if (!current) return;
    if (e.key === 'Escape') { close(); return; }
    if (!current.swiper) return;
    if (e.key === 'ArrowRight') { e.preventDefault(); current.swiper.slideNext(); }
    if (e.key === 'ArrowLeft') { e.preventDefault(); current.swiper.slidePrev(); }
  }

  function open(lb, index, trigger) {
    if (current && current.el !== lb) close();
    var s = state(lb);
    current = s;
    s.lastFocus = trigger || document.activeElement;
    lb.hidden = false;
    document.body.style.overflow = 'hidden';
    ensureSwiper(s, Math.min(Math.max(index, 0), s.total - 1));
    bindDismiss(s);
    // A previous dismiss leaves the content translated; reopening must start
    // square or the image sits off-centre.
    if (s.clearDrag) s.clearDrag();
    // Re-announce the swipe arrows. Reopening an already-built gallery changes
    // no slide, so Swiper fires nothing and ua-swipe-hints would never know a
    // new image just landed on screen.
    if (window.uaSwipeHint) window.uaSwipeHint(s.swiperEl);
    document.addEventListener('keydown', onKeydown);
    s.closeBtn.focus({ preventScroll: true });
  }

  function close() {
    if (!current) return;
    var s = current;
    current = null;
    s.el.hidden = true;
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onKeydown);
    if (s.lastFocus && typeof s.lastFocus.focus === 'function') s.lastFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var closer = e.target.closest('[data-ua-hl-close]');
    if (closer && current && current.el.contains(closer)) { e.preventDefault(); close(); return; }
    var trigger = e.target.closest('[data-hl-open]');
    if (!trigger) return;
    var lb = document.getElementById(trigger.getAttribute('data-hl-target') || '');
    if (!lb) return;
    e.preventDefault();
    open(lb, parseInt(trigger.getAttribute('data-hl-open'), 10) || 0, trigger);
  });
})();
